import { Component, Input } from '@angular/core';
import { SocioEmotionalSkill } from '../../socio-emotional-skills-test/socio-emotional-skills-test.models';
import { SkillScore } from '../socio-emotional-skills-test-results.models';
import { getLevel } from '../utils/socio-emotional-skills-test-results.utils';

@Component({
  selector: 'app-socio-emotional-skills-test-results-progress-table',
  templateUrl: './socio-emotional-skills-test-results-progress-table.component.html',
  styleUrls: ['./socio-emotional-skills-test-results-progress-table.component.scss']
})
export class SocioEmotionalSkillsTestResultsProgressTableComponent {
  @Input() skills: SocioEmotionalSkill[] = [];
  @Input() skillScores: SkillScore[] = [];

  getProgressData() {
    const scoreData = this.skills.map((skill) => {
      const scoreObj = this.skillScores.find(s => s.skill._id === skill._id);
      const score = scoreObj?.average ?? 0;
      const level = getLevel(skill, score);
      const color = level.color || '#000';

      return {
        name: skill.name,
        score,
        color,
        levelName: level?.name || 'Sin nivel',
        levelDescription: level?.description || 'Sin descripción',
      };
    });

    return scoreData.sort((a, b) => b.score - a.score);
  }

}
